require('dotenv').config();
/* eslint-disable max-len */

module.exports = {
  // default locale is the first one
  locales: [
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    'es',
    'fr-FR',
    'ru-RU',
    'ja-JP',
    'id-ID',
    'hr-HR',
    'zh-CN',
    'sv-SE',
    'ar',
    /* @intl-code-template-end */
  ],

  // Node.js app
  port: process.env.PORT || 3000,

  trustProxy: process.env.TRUST_PROXY || 'loopback', // https://expressjs.com/en/guide/behind-proxies.html

  siteUrl: process.env.SITE_URL || 'http://localhost:3000', // SITE URL

  api: { // API Gateway
    clientUrl: process.env.API_CLIENT_URL, // API URL to be used in the client-side code
    serverUrl: process.env.API_SERVER_URL || `http://localhost:${process.env.PORT || 3000}`, // API URL to be used in the server-side code
    apiEndpoint: process.env.API_ENDPOINT_URL || 'http://localhost:4000',
    socketUrl: process.env.SOCKET_URL || 'http://localhost:4001',
  },

  databaseUrl: process.env.DATABASE_URL, // Database

  licenseuploadDir: process.env.LICENSE_UPLOAD_DIR,  // Licence Upload

  vehicleUploadDir: process.env.VEHICLE_UPLOAD_DIR,// Vehicle Upload

  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR,  // Profile photo upload

  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR, // category photo upload

  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR,  // Logo photo upload

  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR,// homepage photo upload

  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR,  // staticpage photo upload

  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR,  // Content page photo upload

  faviconUploadDir: process.env.FAVICON_UPLOAD_DIR,  // favicon upload

  ogImageUploadDir: process.env.OGIMAGE_UPLOAD_DIR, // OG Image Upload

  tripToneUploadDir: process.env.TRIPTONE_PHOTO_UPLOAD_DIR,  // tripTone upload

  promoCodeImageUploadDir: process.env.PROMOCODE_IMAGE_UPLOAD_DIR,  // Promocode image directoy

  googleMapAPI: process.env.GOOGLE_MAP_SERVER_KEY, // Google map api key
  googleMapServerKey: process.env.GOOGLE_MAP_SERVER_KEY,

  analytics: { // https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },

  auth: { // Authentication
    jwt: { secret: process.env.JWT_SECRET },

    facebook: { // https://developers.facebook.com/
      id: process.env.FACEBOOK_APP_ID || '<Your facebook ID>',
      secret: process.env.FACEBOOK_APP_SECRET || '<Your facebook key>',
    },

    google: { // https://cloud.google.com/console/project
      id: process.env.GOOGLE_CLIENT_ID || '<Your google ID>',
      secret: process.env.GOOGLE_CLIENT_SECRET || '<Your google key>',
    },

    twitter: { // https://apps.twitter.com/
      key: process.env.TWITTER_CONSUMER_KEY || '<Your twitter ID>',
      secret: process.env.TWITTER_CONSUMER_SECRET || '<Your twitter key>',
    },

  },

  unitTypes: {
    km: { value: 'metric', convertFromMeter: 1000 },
    mile: { value: 'imperial', convertFromMeter: 1609 },
  },

  startDayOfWeek: 1,// {Sunday = 0, Monday = 1, Tuesday = 2, Wednesday = 3, Thrusday = 4, Friday = 5, Saturday = 6}

  cronTimezone: process.env.CRON_TIMEZONE,

  placeDetailURL: process.env.PLACE_DETAILS_URL,
  autoCompleteURL: process.env.PLACES_AUTOCOMPLETE_URL,
  distanceRouteURL: process.env.DISTANCE_ROUTE_URL,
  directionsRouteURL: process.env.DIRECTION_ROUTE_URL,
};
